import React from 'react';
import getBlogsOrderBy from '../../api/getBlogsOrderBy';
import getBlogsByTitle from '../../api/getBlogsByTitle';
import './BlogFunc.css';

export default class BlogFun extends React.Component {
  state={
    searchText:"",   
  }

  handleFilterBy = (method) => {
    getBlogsOrderBy(method)
    .then(blogsInfo => {
      this.props.handleUpdateBlogs(blogsInfo);
    })
  }

  handleSearch = () => {
    getBlogsByTitle(this.state.searchText)
    .then(blogsInfo => {
        this.props.handleUpdateBlogs(blogsInfo);    
    })
  }

  handleInput = (event) => {
    this.setState({searchText:event.target.value});
  }

  render() {
    return (
      <div className="blog-func-container">
        <div className="blog-count">Total number of blogs: {this.props.numberOfBlogs}</div>
        <div className="blog-search-container">
          <input
            type="search"
            name="blogName"
            className="blog-search"
            maxLength="300"
            placeholder="Blog name"
            onChange={(e) => this.handleInput(e)}
            value={this.state.searchText}
          />
          <button name="search" onClick={this.handleSearch}><i className="fas fa-search"></i></button>
        </div>
        
        <div className="blog-filter-container">
          <button onClick={() => this.handleFilterBy("time")}>Time</button>
          <button onClick={() => this.handleFilterBy("view")}>View</button>
        </div>
      </div>
    )
  }
}